// require('./stylesheets/index.sass');
require('./stylesheets/style.scss')
// require('./stylesheets/pos.sass')
// require('./stylesheets/index.sass')

angular.module('pages.templates', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.templates', {
			url: 'templates',
			template: require('./templates/index.html'),
			controller: require('./controllers/templates'),
			data: {
				restricted: true,
				breadcrumbs: 'MENU.TEMPLATES'
			},
			pageTrack: '/templates'
		})
}

module.exports = 'pages.templates';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/templates/index.js
 ** module id = 297
 ** module chunks = 1
 **/